@if (src(); as src) {
  @if (isVideo()) {
    <video class="su-media-video" controls preload="metadata" [src]="src" [poster]="poster() ?? ''"></video>
  } @else if (zoomable()) {
    <div
      class="su-media-image su-media-image--zoomable"
      role="button"
      tabindex="0"
      [attr.aria-label]="'ADMIN.systemUpdates.media.enlarge' | translate"
      (click)="expand()"
      (keydown.enter)="expand()"
    >
      <img [src]="src" [alt]="title()" />
    </div>
  } @else {
    <div class="su-media-image">
      <img [src]="src" [alt]="title()" />
    </div>
  }
}
